import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp';
// eslint-disable-next-line import/no-webpack-loader-syntax
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import 'mapbox-gl/dist/mapbox-gl.css';
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import centroid from '@turf/centroid';

import { FarmContext } from './FarmContext';
import { AppContext } from './AppContext';

mapboxgl.workerClass = MapboxWorker;
mapboxgl.accessToken = 'pk.eyJ1IjoibWljaGFlbC1hLWFjcmV0cmFkZXIiLCJhIjoiY2ttbXY3Z2s5MW9qNzJubzRrdnU2Mzl1byJ9.b5ZgqtYYRoQoG01qdRxiPA';

const Mapbox = ({ layers, preAdd, postAdd }) => {
  const { mapCenterRef, mapZoomRef, mapboxRef } = React.useContext(AppContext);

  const { boundary, onLoad } = React.useContext(FarmContext);

  const mapContainer = useRef();

  useEffect(() => {
    // if (!mapboxRef.current) {
      let center = mapCenterRef.current;
      try {
        center = centroid(boundary).geometry.coordinates;
      }
      catch (e) {
        console.log('unable to find centroid', boundary);
      }
      
      const map = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/satellite-streets-v11',
        // style: 'mapbox://styles/mapbox/dark-v10',
        center: center,
        zoom: mapZoomRef.current
      });
      
      mapboxRef.current = map;
      window.map = map;

      map.addControl(
        new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl
        }),
      'top-left');

      // TODO moving? probalby need one map
      map.on('move', () => {
        const {lng, lat} = map.getCenter();
        mapCenterRef.current =[lng, lat];
        mapZoomRef.current = map.getZoom();
      });

      map.on('load', function () {
        // map.addLayer(mapunitpolyextended);

        preAdd && preAdd(map);

        layers && layers.forEach(l => {
          if (l.type === 'raster') map.addLayer(l, "tunnel-primary-secondary-tertiary-case")
          else map.addLayer(l);
        });

        postAdd && postAdd(map);

        onLoad();

      });

    
    return () => {
      mapboxRef.current.remove();
    
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>
    <div className="map-container" ref={mapContainer} />
  </>;
};

export default Mapbox;